import isArray from 'lodash/isArray';
import { CompanyName } from 'modules/utils/ConfigUtils';
import getMessageText from 'screens/Messaging/rtf/rtfComponents';
import {
  MessageComposeScreenNavigationParams,
  MessageDetail,
  MessageSummary
} from 'store/messaging/types';

export const createMessageComposeParamsFromMessageDetails = (
  message: MessageDetail
): Partial<MessageComposeScreenNavigationParams> => {
  const { subject, id } = message;
  const replyBody = getMessageText(message);

  return { subject, readonly: replyBody, previousMessageId: id };
};

// replyText can be either a string or an array of strings to accommodate different message body types
// Getting parsed through the getMessageText function above both cases need to be accounted for
export const formatMessageBody = (text: string, replyText?: string | string[]) => {
  if (!replyText) {
    return text;
  }

  let replyWithTabs = '';
  if (isArray(replyText)) {
    replyWithTabs = replyText
      ?.map((textValue: string) =>
        textValue
          ?.split('\n')
          ?.map(line => `\t${line}`)
          ?.join('\n')
      )
      ?.join('\n');
  } else {
    replyWithTabs = replyText
      ?.split('\n')
      ?.map(line => `\t${line}`)
      ?.join('\n');
  }

  return `${text}\n\nOriginal Message:\n${replyWithTabs}`;
};

export const getInboxMessageForSearching = (messages: MessageSummary[]) =>
  messages.map(message => {
    const msg = { ...message };
    msg.senderDisplayName = msg.senderDisplayName || msg.senderFullName || CompanyName;
    return msg;
  });
